/**
 * @author Peter
 * @email [hoangvanlam9988@gmail.com]
 * @create date 2022-02-17 11:02:12
 * @modify date 2022-02-17 11:02:12
 * @desc [description]
 */

import { mainAxios } from "libs/axios";

/** Article Group Sale */
interface ArticleGroupSaleProps {
  page?: number | "";
  size?: number | "";
  query?: string | "";
  startTime?: any | "";
  endTime?: any | "";
  categoryCode?: string | "GPNOTICE";
}

export const getArticleGroupSale = (payload: ArticleGroupSaleProps) => {
  return mainAxios.request({
    methodType: "POST",
    url: "/article/get-all",
    payload: payload,
  });
};

/** Get Group Sale List*/
interface GroupSaleListProps {
  querySearch?: string;
  typeSearch?: "UPCOMING" | "ON_GOING" | "WAITING_DONE" | "ENDED" | "NOT_ENDED";
  page?: number | 1;
  size?: number | 10;
}

export const getGroupSaleList = (params: GroupSaleListProps) => {
  return mainAxios.request({
    methodType: "GET",
    url: "/gp/find",
    params: params,
    notError: true,
    getError: true,
    requiresToken: true,
  });
};

/** Get Group Sale List*/
interface GroupSaleDetailProps {
  id?: number;
}

export const getGroupSaleDetail = (params: GroupSaleDetailProps) => {
  return mainAxios.request({
    methodType: "GET",
    requiresToken: true,
    url: "/gp/gp-detail",
    params: params,
  });
};

interface OnSaleOrderProps {
  address?: string;
  bankAccount?: string;
  bankHolderName?: string;
  bankName?: string;
  buyerName?: string;
  email?: string;
  id?: string;
  incomeDeduction?: string;
  invoiceInfo?: string;
  invoiceType?: string;
  note?: string;
  phone?: string;
  zipCode?: string;
  pointUsing?: number;
  groupPurchaseId?: number;
  unitBuy?: number;
  getInvoice?: boolean;
  token?: string;
  justCheck?: boolean;
  transDTShinhan?: string;
}

export const postFormHaveSlot = (
  isArtWaiting: boolean,
  payload: OnSaleOrderProps
) => {
  return mainAxios.request({
    methodType: "POST",
    requiresToken: true,
    url: isArtWaiting ? "/gp/join-gp-waiting" : "/gp/join-gp",
    payload: {
      ...payload,
      isArtWaiting: undefined,
    },
    notError: true,
    getError: true,
  });
};

export const postFormHaveSlotV2 = (
  isArtWaiting: boolean,
  payload: OnSaleOrderProps
) => {
  return mainAxios.request({
    methodType: "POST",
    requiresToken: true,
    url: isArtWaiting ? "/gp-v2/join-gp-waiting" : "/gp-v2/join-gp",
    payload: {
      ...payload,
      isArtWaiting: undefined,
    },
  });
};

export const postOrderEventV2 = (payload: OnSaleOrderProps) => {
  return mainAxios.request({
    methodType: "POST",
    requiresToken: true,
    url: "/gp-v2/join-gp-random",
    payload: payload,
  });
};

export const postOrderEventV3 = (payload: OnSaleOrderProps) => {
  return mainAxios.request({
    methodType: "POST",
    requiresToken: true,
    url: "/gp-v3/join-gp",
    payload: payload,
    notError: true,
    getError: true,
  });
};

/** Check has the order when go to detail page*/
interface CheckStatusOrderProps {
  groupPurchaseId?: number;
}

export const checkStatusOrder = (params: CheckStatusOrderProps) => {
  return mainAxios.request({
    methodType: "GET",
    requiresToken: true,
    url: "/gp/my-order",
    params: params,
  });
};

export const postModalSurvey = (payload: any) => {
  return mainAxios.request({
    methodType: "POST",
    requiresToken: true,
    url: "/user/gp-test",
    payload: payload,
  });
};

export const recheckLinkAccount = () => {
  return mainAxios.request({
    methodType: "GET",
    requiresToken: true,
    url: "/shinhan/recheck-link-account",
  });
};

export const confirmShinhanApplyOrder = (payload: any) => {
  return mainAxios.request({
    methodType: "POST",
    requiresToken: true,
    url: "/gp-v3/confirm-shinhan-apply-order",
    payload: payload,
  });
};

export const confirmShinhanApplyOrderCancel = (payload: any) => {
  return mainAxios.request({
    methodType: "POST",
    requiresToken: true,
    url: "/gp-v3/req-cancel-order",
    payload: payload,
  });
};

interface GroupSaleScheduleProps {
  year?: number;
  month?: number;
}

export const getGroupSaleSchedule = (params: GroupSaleScheduleProps) => {
  return mainAxios.request({
    methodType: "GET",
    url: "/gp/schedule",
    params: params,
    notError: true,
    getError: true,
    requiresToken: true,
  });
};
